import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetCurrentProject } from 'app/store/project/current-project/current-project.actions';
import { getRootCouriers } from 'app/store/root/couriers/couriers.actions';
import { rootCouriersState } from 'app/store/root/couriers/couriers.selectors';
import { getDocuments } from 'app/store/root/documents/documents.actions';
import { devDocumentsState } from 'app/store/root/documents/documents.selectors';
import { getProjects } from 'app/store/root/projects/projects.actions';
import { rootProjectsState } from 'app/store/root/projects/projects.selectors';
import { getSimpleExtensions } from 'app/store/root/simple-extensions/simple-extensions.actions';
import { simpleExtensionsState } from 'app/store/root/simple-extensions/simple-extensions.selectors';
import { getUsers } from 'app/store/root/users/users.actions';
import { usersState } from 'app/store/root/users/users.selectors';
import { getWebhooks } from 'app/store/root/webhooks/webhooks.actions';
import { webhooksState } from 'app/store/root/webhooks/webhooks.selectors';
import { forkJoin, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

@Injectable()
export class RootStateResolver {
  constructor(private store$: Store) { }

  resolve(): Observable<any> {
    this.store$.dispatch(getProjects());
    this.store$.dispatch(getUsers());
    this.store$.dispatch(getDocuments());
    this.store$.dispatch(getWebhooks());
    this.store$.dispatch(getRootCouriers());
    this.store$.dispatch(getSimpleExtensions());

    return forkJoin({
      projects: this.store$.select(rootProjectsState).pipe(first(s => s.isLoaded)),
      users: this.store$.select(usersState).pipe(first(s => s.isLoaded)),
      documents: this.store$.select(devDocumentsState).pipe(first(s => s.isLoaded)),
      webhooks: this.store$.select(webhooksState).pipe(first(s => s.isLoaded)),
      couriers: this.store$.select(rootCouriersState).pipe(first(s => s.isLoaded)),
      simpleExtensions: this.store$.select(simpleExtensionsState).pipe(first(s => s.isLoaded)),
    }).pipe(
      tap(() => this.store$.dispatch(resetCurrentProject())),
    );
  }
}
